import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Input, Row, Col, Spinner, Label, Collapse, Form } from "reactstrap";
import Select from 'react-select'
import WaterfallRecharts from "./Graficos/WaterfallRecharts";
import PieChartRecharts from "./Graficos/PieChartRecharts";
import TotalizadorDadosDRE from "./Graficos/TotalizadorDadosDRE";
import DetalhadoDadosDRE from "./Graficos/DetalhadoDadosDRE";
import { CSVLink } from "react-csv";
import AddIcon from '@material-ui/icons/Add';


//utils
import { showMessage } from "utils/message.js";
import { getSessionCookie } from 'utils/cookies';
import { formateMesAno, formateCurrencyInput, formateCurrencyApi, formateDateByMesAno, formateCurrencyValueApi } from "utils/formats";
import { monthDiff } from "utils/generics";

// api
import usuario_api from "api/usuario_api.js";
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api';
import dashboardbi_api from "api/dashboardbi_api";
import { IconButton } from "@material-ui/core";

export default function DashboardConsolidadoBI({ }) {
    const { register, handleSubmit, setValue, clearErrors, errors } = useForm({ mode: "onBlur" });

    var session = getSessionCookie();

    const exportRef = React.useRef(null);

    const [showLoading, setshowLoading] = useState(false);

    useEffect(() => {
        //se tiver a permissão habilitade carrega as regionais
        usuario_api.getFuncionalidadeAcaoLiberada("Dashboard", "Visualizar").then((result) => { loadOptionsRegionais(); });

    }, []);

    // Regional
    const [options_regionais, set_options_regionais] = useState([]);
    const loadOptionsRegionais = () => {
        dadosimplantacaotim_api.getRegionais().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _regionais = [];
                result.data.map((m) => _regionais.push({ label: m, value: m }));
                set_options_regionais(_regionais);
                if (_regionais.length == 1) {
                    set_regionais(_regionais);
                    setValue("regional", _regionais, true);
                    loadOptionsSegmentos(_regionais);
                }
            }
        })
    }
    const [regionais, set_regionais] = useState([]);
    const handleChangeRegional = (value) => {
        ClearFiltros("regional");

        loadOptionsSegmentos(value);

        let _regionais = [];
        if (value) {
            value.map(m => {
                _regionais.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_regionais(_regionais);

        if (_regionais.length > 0)
            setValue("regional", _regionais, true);
    }


    const handleClickSelecionarTodasRegionais = () => {
        set_regionais([]);
        loadOptionsSegmentos(options_regionais);

        let _regionais = []
        if (options_regionais.length > 0) {
            options_regionais.map(m => {
                _regionais.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_regionais(_regionais);

        if (_regionais.length > 0)
            setValue("regional", _regionais, true);
    }

    //Segmento
    const [options_segmentos, set_options_segmentos] = useState([]);
    const loadOptionsSegmentos = (_regionais) => {

        let _regionaisArray = [];
        if (_regionais !== null)
            _regionais.map((m) => _regionaisArray.push(m.value));
        else
            _regionais = null;

        dashboardbi_api.getSegmentosbyRegionais(_regionaisArray).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _segmentos = [];
                result.data.map((m) => _segmentos.push({ label: m, value: m }));

                set_options_segmentos(_segmentos);
            }
        })
    }
    const [segmentos, set_segmentos] = useState([]);
    const handleChangeSegmento = (value) => {
        ClearFiltros("segmento");

        loadOptionsMesAno(value);

        let _segmentos = []
        if (value) {
            value.map(m => {
                _segmentos.push({
                    label: m.label,
                    value: m.value
                })
            });
        }

        set_segmentos(_segmentos);

        if (_segmentos.length > 0)
            setValue("segmento", _segmentos, true);

    }

    const handleClickSelecionarTodosSegmentos = () => {
        set_segmentos([]);
        loadOptionsMesAno(options_segmentos);

        let _segmentos = []
        if (options_segmentos.length > 0) {
            options_segmentos.map(m => {
                _segmentos.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_segmentos(_segmentos);

        if (_segmentos.length > 0)
            setValue("segmento", _segmentos, true);
    }


    // MesAno
    const [options_mesAno, set_options_mesAno] = useState([]);
    const loadOptionsMesAno = (_segmentos) => {

        let _segmentosArray = [];
        if (_segmentos !== null)
            _segmentos.map((m) => _segmentosArray.push(m.value));
        else
            _segmentos = null;

        let _regionaisArray = [];
        if (regionais !== null)
            regionais.map((m) => _regionaisArray.push(m.value));

        let json_filtros = {
            regionais: _regionaisArray,
            segmentos: _segmentosArray
        }

        dashboardbi_api.getMesAnoDreMensal(json_filtros).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _meses = [];
                result.data.map((m) => _meses.push({ label: m, value: m }));

                // ordenando os meses e anos em ordem decrescente
                _meses.sort((a, b) => {
                    const [mesA, anoA] = a.value.split('/').map(Number);
                    const [mesB, anoB] = b.value.split('/').map(Number);

                    if (anoB !== anoA) {
                        return anoB - anoA;
                    } else {
                        return mesB - mesA;
                    }
                });

                set_options_mesAno(_meses);
            }
        })
    }

    const [mesano, set_mesano] = useState([]);
    const handleChangeMesAno = (value) => {
        ClearFiltros("mesano");

        loadOptionsGruposEconomicos(value);

        let _meses = [];
        if (value) {
            value.map(m => {
                _meses.push({
                    label: m.label,
                    value: m.value
                });
            })
        }

        set_mesano(_meses);

        if (_meses.length > 0) {
            setValue("mesAno", _meses, true);
            clearErrors("mesAno");
        }
        else {
            setValue("mesAno", [], false);
        }
    }

    const handleClickSelecionarTodosMesAno = () => {
        set_mesano([]);
        loadOptionsGruposEconomicos(options_mesAno);

        let _meses = []
        if (options_mesAno.length > 0) {
            options_mesAno.map(m => {
                _meses.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_mesano(_meses);

        if (_meses.length > 0)
            setValue("mesAno", _meses, true);
    }



    // Grupos Econômicos
    const [options_gruposeconomicos, set_options_gruposeconomicos] = useState([]);
    const loadOptionsGruposEconomicos = (_mesAno) => {
        let _mesAnoArray = [];
        if (_mesAno !== null)
            _mesAno.map((m) => _mesAnoArray.push(m.value));
        else
            _mesAno = null;

        let _segmentosArray = [];
        if (segmentos !== null)
            segmentos.map((m) => _segmentosArray.push(m.value));

        let _regionaisArray = [];
        if (regionais !== null)
            regionais.map((m) => _regionaisArray.push(m.value));

        let json_filtros = {
            regionais: _regionaisArray,
            segmentos: _segmentosArray,
            mesAnoSelecionados: _mesAnoArray
        }

        dashboardbi_api.getGruposEconomicosbyRegionaisSegmentos(json_filtros).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _gruposeconomicos = [];
                result.data.map((m) => _gruposeconomicos.push({ label: m, value: m }));

                set_options_gruposeconomicos(_gruposeconomicos);
            }
        })
    }
    const [gruposeconomicos, set_gruposeconomicos] = useState([]);
    const handleChangeGrupoEconomico = (value) => {
        ClearFiltros("grupo");

        loadOptionsLojas(value);

        let _gruposEconomicos = []
        if (value) {
            value.map(m => {
                _gruposEconomicos.push({
                    label: m.label,
                    value: m.value
                });
            });
        }
        set_gruposeconomicos(_gruposEconomicos);

        if (_gruposEconomicos.length > 0)
            setValue("grupoeconomico", _gruposEconomicos, true);
    }

    const handleClickSelecionarTodosGrupos = () => {
        set_lojas([]);
        loadOptionsLojas(options_gruposeconomicos);

        let _gruposEconomicos = []
        if (options_gruposeconomicos.length > 0) {
            options_gruposeconomicos.map(m => {
                _gruposEconomicos.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_gruposeconomicos(_gruposEconomicos);

        if (_gruposEconomicos.length > 0)
            setValue("grupoeconomico", _gruposEconomicos, true);
    }

    // Lojas
    const [options_lojas, set_options_lojas] = useState([]);
    const loadOptionsLojas = (_gruposeconomicos) => {

        let _gruposeconomicosArray = [];
        if (_gruposeconomicos !== null)
            _gruposeconomicos.map((m) => _gruposeconomicosArray.push(m.value));
        else
            _gruposeconomicos = null;

        let _regionaisArray = [];
        if (regionais !== null)
            regionais.map((m) => _regionaisArray.push(m.value));

        let _mesAnoArray = [];
        if (mesano !== null)
            mesano.map((m) => _mesAnoArray.push(m.value));

        let json_filtros = {
            regionais: _regionaisArray,
            gruposeconomicos: _gruposeconomicosArray,
            mesAnoSelecionados: _mesAnoArray
        }

        dashboardbi_api.getLojasbyGruposERegionais(json_filtros).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _lojas = [];
                result.data.map((m) => _lojas.push({ label: m.identificacao, value: m.custCode }));

                includeMatrizToLojas(_lojas, _gruposeconomicos);

            }
        })
    }

    const includeMatrizToLojas = (lojas, grupos) => {
        //Incluir o escritório matriz de cada grupo economico na lista de lojas
        let _matrizElojas = []
        _matrizElojas = lojas;
        if (grupos !== null) {
            grupos.map(m => {
                _matrizElojas.push({
                    label: "ESCRITÓRIO MATRIZ - " + m.label,
                    value: m.value
                });
            });
        }
        set_options_lojas(_matrizElojas);
    }

    const [lojas, set_lojas] = useState([]);
    const handleChangeLojas = (value) => {
        let _lojas = [];
        let exibeRateioMatriz = false;
        let exibeRateioOutraLoja = false;

        if (value) {
            value.map((m) => {
                if (m.label.indexOf("ESCRITÓRIO MATRIZ - ") !== -1) {// verifica se existe ESCRITÓRIO MATRIZ - selecionado entre as lojas (retornar um valor diferente de -1, significa que a string "ESCRITÓRIO MATRIZ - " foi encontrada na propriedade label do objeto m)
                    exibeRateioMatriz = true;
                } else {
                    exibeRateioOutraLoja = true;
                }

                _lojas.push({
                    label: m.label,
                    value: m.value,
                });
            });
        }

        set_lojas(_lojas);

        if (_lojas.length > 0) {
            setValue("lojas", _lojas, true);
            clearErrors("lojas");
        } else {
            setValue("lojas", [], false);
        }
        //SOMENTE IRÁ EXIBIR O CAMPO RATEIO ADM SE EU TENHO PELOMENOS 1 loja do tipo ESCRITORIO MATRIZ SELECIONADO ENTRE AS LOJAS E PELOMENOS 1 LOJA QUE NÃO SEJA do tipo ESCRITÓRIO MATRIZ SELECIONADA
        if (exibeRateioMatriz && exibeRateioOutraLoja) {
            set_visibleRateio(true);
        } else {
            set_visibleRateio(false);
        }
    };

    const handleClickSelecionarTodasLojas = () => {
        let _lojas = [];

        if (options_lojas.length > 0) {
            options_lojas.map(m => {
                _lojas.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_lojas(_lojas);

        if (_lojas.length > 0) {
            setValue("lojas", _lojas, true);
            clearErrors("lojas");
        }
        else {
            setValue("lojas", [], false);
        }

        set_visibleRateio(true)
    }

    // Rateio ADM
    const [visibleRateio, set_visibleRateio] = useState(false);
    const options_rateioADM = [
        { label: "SIM", value: "SIM" },
        { label: "NÃO", value: "NAO" }
    ];
    const [rateioADM, set_rateioADM] = useState("NAO");
    const handleChangeRateioADM = (value) => {
        set_rateioADM(value);
        clearErrors("rateioAdm");
        setValue("rateioAdm", value, true);
    }

    //Filtrar
    const [totalizadorWaterfall, set_totalizadorWaterfall] = useState(null);
    const [totalizadoresPieChart, set_totalizadoresPieChart] = useState(null);
    const [tableTotalizadoBI, set_tableTotalizadoBI] = useState(null);
    const [visibleGraficoWaterfall, set_visibleGraficovisibleGraficoWaterfall] = useState(false);
    const [visibleGraficoPieChart, set_visibleGraficovisibleGraficoPieChart] = useState(false);
    const [visibleDadosTotalizadosBI, set_visibleDadosTotalizadosBI] = useState(false);
    const [jsonFilter, set_jsonFilter] = useState(null);

    const handleClickFiltrar = () => {

        if (visibleRateio) {
            if (rateioADM == null) {
                showMessage("Aviso", "É necessário selecionar o rateio ADM!", 'error', null);
                return;
            }
        }

        if (lojas.length == 0) {
            showMessage("Aviso", "É necessário selecionar a loja!", 'error', null);
            return;
        }

        let grupsArray = [];
        gruposeconomicos.map((m) => grupsArray.push(m.value));
        let lojasArray = [];
        lojas.map((m) => lojasArray.push(m.value));
        let mesAnoArray = [];
        mesano.map((m) => mesAnoArray.push(m.value));

        let json_filter = {
            lojasSelecionadas: lojasArray,
            rateioADM: rateioADM,
            mesAnoSelecionados: mesAnoArray,
            gruposeconomicos: grupsArray
        }
        set_jsonFilter(json_filter);

        setshowLoading(true);

        //setando a tabela totalizada DRE como null sempre antes de realizar o filtro para não ficar com os dados da ultima pesquisa realizada.
        set_tableTotalizadoBI(null);

        dashboardbi_api.getDadosGraficosBI(json_filter).then(result => {
            if (result.status !== 200) {
                setshowLoading(false);
                showMessage("Aviso", result.message, 'error', null);
                set_visibleGraficovisibleGraficoWaterfall(false);
                set_visibleGraficovisibleGraficoPieChart(false);
                set_visibleDadosTotalizadosBI(false);
            }
            else {
                setshowLoading(false);
                if (result.data.totalWaterfall != null) {
                    set_totalizadorWaterfall(result.data.totalWaterfall);
                    set_visibleGraficovisibleGraficoWaterfall(true);
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleGraficovisibleGraficoWaterfall(false);
                }
                if (result.data.totalImpostoPieChart != null) {
                    set_totalizadoresPieChart(result.data);
                    set_visibleGraficovisibleGraficoPieChart(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleGraficovisibleGraficoPieChart(false);
                }
                if (result.data.totalWaterfall != null && result.data.totalImpostoPieChart != null) {
                    set_tableTotalizadoBI(result.data);
                    set_visibleDadosTotalizadosBI(true);
                    set_visibleFiltros(false);
                    set_btnRollbackFiltro('Exibir Filtros')
                }
                else {
                    set_visibleDadosTotalizadosBI(false);
                    set_visibleFiltros(true);
                }

            }
            set_visibleDadosDetalhadosBI(false);
            set_tableDetalhadoBI(null); // reseta a useState para null pois será necessário fazer uma nova busca para popular ela 
            set_csvData([]);
            set_btnTableDetalhado('Detalhado');
            set_btnExportarCsv(false);
        })
    }

    //limpa os filtros, pois seus dados são dinamicos (dependem do anterior)
    const ClearFiltros = (filtro) => {
        if (filtro == "regional") {
            set_segmentos([]);
            set_options_segmentos([]);
            set_mesano([]);
            set_options_mesAno([]);
            set_gruposeconomicos([]);
            set_options_gruposeconomicos([]);
            set_lojas([]);
            set_options_lojas([]);
            set_visibleRateio(false);
        }
        else if (filtro == "segmento") {
            set_mesano([]);
            set_options_mesAno([]);
            set_gruposeconomicos([]);
            set_options_gruposeconomicos([]);
            set_lojas([]);
            set_options_lojas([]);
            set_visibleRateio(false);
        }
        else if (filtro == "mesano") {
            set_gruposeconomicos([]);
            set_options_gruposeconomicos([]);
            set_lojas([]);
            set_options_lojas([]);
            set_visibleRateio(false);
        }
        else if (filtro == "grupo") {
            set_lojas([]);
            set_options_lojas([]);
            set_visibleRateio(false);
        }
    }

    //voltar a exibir os filtros
    const [btnRollbackFiltro, set_btnRollbackFiltro] = useState('Exibir Filtros');
    const [visibleFiltros, set_visibleFiltros] = useState(true);
    const handleClickFiltros = () => {

        if (btnRollbackFiltro == "Ocultar Filtros") {
            set_visibleFiltros(false);
            set_btnRollbackFiltro('Exibir Filtros')

        }
        else {
            set_visibleFiltros(true);
            set_btnRollbackFiltro('Ocultar Filtros')
        }

    }

    //Table Detalhado
    const [visibleDadosDetalhadosBI, set_visibleDadosDetalhadosBI] = useState(false);
    const [tableDetalhadoBI, set_tableDetalhadoBI] = useState(null);
    const [btnTableDetalhado, set_btnTableDetalhado] = useState('Detalhado');
    const [btnExportarCsv, set_btnExportarCsv] = useState(false);

    const handleClickAlteraTipoTable = () => {

        if (btnTableDetalhado == "Detalhado") {
            setshowLoading(true);
            //se tableDetalhadoBI é null, então é a primeira busca dos dados
            if (tableDetalhadoBI === null) {
                dashboardbi_api.getDadosDetalhadoGraficosBI(jsonFilter).then(result => {
                    if (result.status !== 200) {
                        setshowLoading(false);
                        showMessage("Aviso", result.message, 'error', null);
                        set_btnTableDetalhado('Detalhado');
                        set_visibleDadosDetalhadosBI(false);
                        set_visibleDadosTotalizadosBI(true);
                    }
                    else {
                        set_tableDetalhadoBI(result.data);
                        set_csvData(result.data);
                        set_visibleDadosDetalhadosBI(true);
                        set_visibleDadosTotalizadosBI(false);

                        if (btnTableDetalhado == "Detalhado") {
                            set_btnTableDetalhado('Totalizado');
                            set_btnExportarCsv(true);
                        }
                        else {
                            set_btnRollbackFiltro('Detalhado');
                            set_btnExportarCsv(false);
                        }

                        setshowLoading(false);
                    }
                })
            }// Se não, significa que já foi feito requisição pelomenos 1 vez, e dessa forma já tem os dados Detalhado, e não precisa fazer requisição novamente para buscar os dados
            else {
                set_visibleDadosDetalhadosBI(true);
                set_visibleDadosTotalizadosBI(false);
                set_btnTableDetalhado('Totalizado');
                set_btnExportarCsv(true);
                setshowLoading(false);
            }

        }
        else {
            set_visibleDadosDetalhadosBI(false);
            set_visibleDadosTotalizadosBI(true);
            set_btnTableDetalhado('Detalhado');
            set_btnExportarCsv(false);
            setshowLoading(false);
        }
    }

    const headersExport = [
        { label: "IDENTIFICAÇÃO", key: "identificacao" },
        { label: "RECEITA BRUTA", key: "dados.totalWaterfall.totalReceitaBruta" },
        { label: "SERVIÇO", key: "dados.receitaBrutaServico" },
        { label: "COMISSÃO", key: "dados.comissao" },
        { label: "SEGURO APARELHO", key: "dados.seguroAparelho" },
        { label: "RECARGA", key: "dados.recarga" },
        { label: "PRODUTO", key: "dados.receitaBrutaProduto" },
        { label: "REBATE", key: "dados.rebate" },
        { label: "ADM", key: "dados.adm" },
        { label: "PRICE OFERTA", key: "dados.priceOferta" },
        { label: "PRICE PROTECTION", key: "dados.priceProtection" },
        { label: "PRICE BACK", key: "dados.priceBack" },
        { label: "APARELHO", key: "dados.aparelho" },
        { label: "CHIP", key: "dados.chip" },
        { label: "ACESSÓRIO", key: "dados.acessorio" },
        { tipo: "titulo", label: "IMPOSTO", key: "dados.totalWaterfall.totalImposto" },
        { label: "PIS/COFINS - Serviço", key: "dados.pisCofinsServico" },
        { label: "PIS/COFINS - Seguro", key: "dados.pisCofinsSeguro" },
        { label: "PIS/COFINS - Chip", key: "dados.pisCofinsChip" },
        { label: "PIS/COFINS - Recarga", key: "dados.pisCofinsRecarga" },
        { label: "PIS/COFINS - Aparelho", key: "dados.pisCofinsAparelho" },
        { label: "PIS/COFINS - Acessório", key: "dados.pisCofinsAcessorio" },
        { label: "ICMS - Chip", key: "dados.icmsChip" },
        { label: "ICMS - Aparelho", key: "dados.icmsAparelho" },
        { label: "ICMS - Acessório", key: "dados.icmsAcessorio" },
        { label: "ICMS-ST Aparelho", key: "dados.icmsSTAparelho" },
        { label: "ISS", key: "dados.iss" },
        { label: "SIMPLES NACIONAL", key: "dados.totalImpostoPieChart.totalImpostoSimplesNacional" },
        { tipo: "titulo", label: "RECEITA LÍQUIDA", key: "dados.totalWaterfall.totalReceitaLiquida" },
        { label: "CMV", key: "dados.totalWaterfall.totalCmv" },
        { label: "APARELHO - CMV", key: "dados.cmvAparelho" },
        { label: "CHIP - CMV", key: "dados.cmvChip" },
        { label: "ACESSÓRIO - CMV", key: "dados.cmvAcessorio" },
        { tipo: "titulo", label: "RECEITA OPERACIONAL", key: "dados.totalWaterfall.totalReceitaOperacional" },
        { label: "PRODUTO", key: "dados.receitaOperacionalProduto" },
        { label: "SERVIÇO", key: "dados.receitaOperacionalServico" },
        { tipo: "titulo", label: "DESPESA", key: "dados.totalWaterfall.totalDespesa" },
        { label: "DESPESA PESSOAL", key: "dados.totalDespesaPieChart.totalPessoal" },
        { label: "VENDEDOR", key: "dados.vendedor" },
        { label: "GERENTE", key: "dados.gerente" },
        { label: "CAIXA", key: "dados.caixa" },
        { label: "ADMINISTRATIVO", key: "dados.administrativo" },
        { label: "DESPESA OCUPAÇÃO", key: "dados.totalDespesaPieChart.totalOcupacao" },
        { label: "ALUGUEL", key: "dados.aluguel" },
        { label: "ALUGUEL PERCENTUAL", key: "dados.aluguelPorcentual" },
        { label: "CONDOMÍNIO", key: "dados.condominio" },
        { label: "FUNDO PROMOÇÃO", key: "dados.fundoPromocao" },
        { label: "DÉCIMO TERCEIRO ALUGUEL", key: "dados.decimoTerceiroAluguel" },
        { label: "IPTU", key: "dados.iptu" },
        { label: "CRÉDITO PIS/COFINS", key: "dados.creditoPISCOFINS" },
        { label: "OUTRAS", key: "dados.outras" },
        { label: "DESPESA COM CARTÃO", key: "dados.totalDespesaPieChart.totalCartao" },
        { label: "TAXA CARTÃO MDR", key: "dados.taxaCartaoMDR" },
        { label: "ALUGUEL DA MÁQUINA", key: "dados.aluguelMaquina" },
        { label: "DESPESA ESTRUTURAL", key: "dados.totalDespesaPieChart.totalEstrutural" },
        { label: "AÇÃO DE VENDAS", key: "dados.acoesVendas" },
        { label: "CONTABILIDADE", key: "dados.contabilidade" },
        { label: "ENERGIA", key: "dados.energiaTaxas" },
        { label: "JURÍDICO", key: "dados.juridico" },
        { label: "LIMPEZA", key: "dados.limpeza" },
        { label: "MANUTENÇÃO", key: "dados.manutencao" },
        { label: "MATERIAL DE ESCRITÓRIO", key: "dados.materiais" },
        { label: "MOTOBOY", key: "dados.motoboy" },
        { label: "SEGURO LOJA", key: "dados.seguros" },
        { label: "SISTEMAS", key: "dados.sistemas" },
        { label: "TELEFONE E INTERNET", key: "dados.telefoniaInternet" },
        { label: "OUTROS", key: "dados.outros" },
        { label: "EVENTOS", key: "dados.eventos" },
        { label: "SANEAMENTO BÁSICO", key: "dados.saneamentoBasico" },
        { label: "SEGURANÇA MONITORAMENTO", key: "dados.segurancaMonitoramento" },
        { label: "CONTRIBUIÇÃO SINDICAL", key: "dados.contribuicaoSindical" },
        { label: "EMPRESA TERCEIRIZADA", key: "dados.empresaTerceirizada" },
        { label: "UNIFORMES", key: "dados.uniformes" },
        { label: "RECRUTAMENTO SELEÇÃO", key: "dados.recrutamentoSelecao" },
        { label: "PROCESSO JUDICIAL", key: "dados.processoJudicial" },
        { label: "DESPESA GRÁFICA", key: "dados.despesaGrafica" },
        { label: "FRETES CARRETO", key: "dados.fretesCarreto" },
        { label: "REPRESENTAÇÕES VIAGENS", key: "dados.representacoesViagensTransporte" },
        { label: "IRALUGUEL", key: "dados.irAluguel" },
        { label: "PERDA ROUBO BAIXA ESTOQUE", key: "dados.perdaRouboBaixaEstoque" },
        { tipo: "titulo", label: "EBITDA", key: "dados.totalWaterfall.totalEbitda" },
        { tipo: "titulo", label: "% EBITDA", key: "dados.percentualEbitda" },
        { tipo: "tituloIndicador", label: "INDICADORES", key: "dados." },
        { label: "QTD PDV", key: "dados.qtdPDV" },
        { label: "FUNCIONÁRIOS", key: "dados." },
        { label: "VENDEDOR | QTD", key: "dados.vendedorQtd" },
        { label: "VENDEDOR | UNITÁRIO", key: "dados.vendedorUnitario" },
        { label: "GERENTE | QTD", key: "dados.gerenteQtd" },
        { label: "GERENTE | UNITÁRIO", key: "dados.gerenteUnitario" },
        { label: "CAIXA | QTD", key: "dados.caixaQtd" },
        { label: "CAIXA | UNITÁRIO", key: "dados.caixaUnitario" },
        { label: "ADMINISTRATIVO | QTD", key: "dados.administrativoQtd" },
        { label: "ADMINISTRATIVO | UNITÁRIO", key: "dados.administrativoUnitario" },
        { label: "PRODUTO", key: "dados." },
        { label: "APARELHO | QTD", key: "dados.aparelhoQtd" },
        { label: "APARELHO | TKM", key: "dados.aparelhoTKM" },
        { label: "APARELHO | CMV", key: "dados.aparelhoTKMCMV" },
        { label: "CHIP | QTD", key: "dados.chipQtd" },
        { label: "CHIP | TKM", key: "dados.chipTKM" },
        { label: "CHIP | CMV", key: "dados.chipTKMCMV" },
        { label: "ACESSÓRIO | QTD", key: "dados.acessorioQtd" },
        { label: "ACESSÓRIO | TKM", key: "dados.acessorioTKM" },
        { label: "ACESSÓRIO | CMV", key: "dados.acessorioTKMCMV" },
        { label: "VOLUME DATASYS", key: "dados." },
        { label: "PÓS PURO", key: "dados.posPuro" },
        { label: "CONTROLE", key: "dados.controle" },
        { label: "UPGRADE", key: "dados.upgrade" }
    ];

    const [csvData, set_csvData] = useState([]);

    const handleExportar = () => {
        exportRef.current.link.click();
    }


    // estilos
    const customStyles = {
        valueContainer: (provided, state) => ({
            ...provided,
            height: '60px',
            padding: '0 6px',
            overflow: 'auto'
        })
    };

    const ColoredLine = ({ color }) => (
        <hr
            style={{
                color: color,
                backgroundColor: "#343a40",
                height: 35,
                display: 'flex',
                alignItems: "center",
                flex: 1,
                opacity: 0.2

            }}
        />
    );

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }

            <div className="content">
                {totalizadoresPieChart != null &&
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-right">
                            <Button color="warning" type="button" onClick={handleClickFiltros}><i className="fas fa-filter"></i> {btnRollbackFiltro}</Button>
                        </Col>
                    </Row>
                }
                {visibleFiltros &&
                    <>
                        <Row className="mb-4 align-items-end">
                            <Col lg="4" md="6" sm="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6" md="12" sm="12">
                                            <label className="form-control-label">Regional *</label>
                                        </Col>
                                        <Col lg="6" md="12" sm="12">
                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodasRegionais()} style={{ marginTop: '10px' }}>
                                                    {'Selecionar Todos'}
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Select
                                        name="regional"
                                        options={options_regionais}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_regionais.filter(({ value }) => regionais.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeRegional(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "regional" })
                                        }
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="6" sm="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6" md="12" sm="12">
                                            <label className="form-control-label">Segmento *</label>
                                        </Col>
                                        <Col lg="6" md="12" sm="12">
                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodosSegmentos()} style={{ marginTop: '10px' }}>
                                                    {'Selecionar Todos'}
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Select
                                        name="segmento"
                                        options={options_segmentos}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_segmentos.filter(({ value }) => segmentos.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeSegmento(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "segmento" })
                                        }
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="6" sm="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6" md="12" sm="12">
                                            <label className="form-control-label">Mês/Ano *</label>
                                        </Col>
                                        <Col lg="6" md="12" sm="12">
                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodosMesAno()} style={{ marginTop: '10px' }}>
                                                    {'Selecionar Todos'}
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Select
                                        name="mesAno"
                                        options={options_mesAno}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_mesAno.filter(({ value }) => mesano.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeMesAno(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "mesAno" })
                                        }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6" md="12" sm="12">
                                            <label className="form-control-label">Grupo Econômico *</label>
                                        </Col>
                                        <Col lg="6" md="12" sm="12">
                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodosGrupos()} style={{ marginTop: '10px' }}>
                                                    {'Selecionar Todos'}
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Select
                                        name="grupoeconomico"
                                        styles={customStyles}
                                        options={options_gruposeconomicos}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_gruposeconomicos.filter(({ value }) => gruposeconomicos.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeGrupoEconomico(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "grupoeconomico" })
                                        }
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="6" md="12" sm="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6" md="6" sm="12">
                                            <label className="form-control-label">Lojas *</label>
                                        </Col>
                                        <Col lg="6" md="6" sm="12">
                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodasLojas()} style={{ marginTop: '10px' }}>
                                                    {'Selecionar Todos'}
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Select
                                        name="lojas"
                                        styles={customStyles}
                                        options={options_lojas}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_lojas.filter(({ value }) => lojas.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeLojas(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "lojas" })}
                                    />
                                </FormGroup>
                            </Col>
                            {visibleRateio &&
                                <Col lg="2" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Rateio ADM *</label>
                                        <Select
                                            name="rateioAdm"
                                            options={options_rateioADM}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_rateioADM.filter(f => f.value == rateioADM)}
                                            defaultValue="NAO"
                                            onChange={(o) => handleChangeRateioADM(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register({ name: "rateioAdm" })}
                                        />
                                    </FormGroup>
                                </Col>
                            }
                        </Row>
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="info" type="button" onClick={handleClickFiltrar}><i className="fas fa-filter"></i> Filtrar</Button>
                            </Col>
                        </Row>
                    </>
                }
                {visibleGraficoWaterfall &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>WATERFALL DRE</strong></h5>
                        </Col>
                        <Col lg="12" md="12" sm="12" style={{ marginTop: '10px' }}>
                            <WaterfallRecharts totalizadorWaterfall={totalizadorWaterfall}></WaterfallRecharts>
                        </Col>
                    </Row>
                }

                {visibleGraficoPieChart &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>GASTOS DRE</strong></h5>
                        </Col>
                        <Col lg="12" md="12" sm="12" style={{ marginLeft: '20px', marginTop: '20px' }}>
                            <PieChartRecharts totalizadoresPieChart={totalizadoresPieChart}></PieChartRecharts>
                        </Col>
                    </Row>
                }

                {(visibleDadosTotalizadosBI || visibleDadosDetalhadosBI) &&

                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>DRE</strong></h5>
                        </Col><br></br>
                        <Col lg="12" md="12" sm="12" className="text-right">
                            {btnExportarCsv &&
                                <Button color="success" type="button" onClick={handleExportar}><i className="fas fa-download"></i>  Exportar</Button>}
                            {btnExportarCsv && csvData.length > 0 &&
                                <CSVLink data={csvData} headers={headersExport} filename="DRE Mensal.csv" target="_blank" ref={exportRef}></CSVLink>
                            }
                            <Button color="info" type="button" onClick={handleClickAlteraTipoTable}><i className="fas fa-expand"></i>&ensp;{btnTableDetalhado}</Button>
                        </Col><br></br>
                        {visibleDadosTotalizadosBI && tableTotalizadoBI != null &&
                            <Col lg="12" md="12" sm="12" style={{ marginTop: '20px' }}>
                                <TotalizadorDadosDRE tableTotalizadoBI={tableTotalizadoBI}></TotalizadorDadosDRE>
                            </Col>
                        }

                        {visibleDadosDetalhadosBI &&
                            <Col lg="12" md="12" sm="12" style={{ marginTop: '20px' }}>
                                <DetalhadoDadosDRE tableDetalhadoBI={tableDetalhadoBI}></DetalhadoDadosDRE>
                            </Col>
                        }
                    </Row>
                }

            </div>

        </>
    );
}